enum EndorsementEntityField {
	DEDUCTIBLES = 'Deductibles',

	PROPERTY_ADDRESS_1 = 'Risk.Address.Address.AddressLine1',
	PROPERTY_ADDRESS_2 = 'Risk.Address.Address.AddressLine2',
	PROPERTY_CITY = 'Risk.Address.Address.City',
	PROPERTY_STATE = 'Risk.Address.Address.State',
	PROPERTY_ZIP = 'Risk.Address.Address.PostalCode',
	PROPERTY_GPS_COORDIANTES = 'Risk.Address.GpsCoordinates',

	PROPERTY_OCCUPANCY_TYPE = 'Risk.BuildingData.OccupancyType',
	PROPERTY_YEAR_ROOF_LAST_UPDATE = 'Risk.BuildingData.YearRoofLastUpdated',
	PROPERTY_IS_BELOW_GRADE_OR_ENCLOSED_AREA_FINISHED = 'Risk.BuildingData.IsBelowGradeOrEnclosedAreaFinished',
	PROPERTY_IS_GARAGE_ATTACHED = 'Risk.BuildingData.IsGarageAttached',
	PROPERTY_CONSTRUCTION_TYPE = 'Risk.BuildingData.ConstructionType',
	PROPERTY_FOUNDATION_TYPE_DETAIL = 'Risk.BuildingData.FoundationTypeDetail',
	PROPERTY_RCV = 'Risk.BuildingData.BuildingReplacementCostValue',
	PROPERTY_FLOOD_ZONE = 'Risk.BuildingData.FloodZone',
	PROPERTY_BUILDING_USE = 'Risk.BuildingData.BuildingUse',
	PROPERTY_SQUARE_FEET = 'Risk.BuildingData.SquareFeet',
	PROPERTY_NUMBER_STORIES_ABOVE_GRADE = 'Risk.BuildingData.NumberStoriesAboveGrade',
	PROPERTY_YEAR_OF_CONSTRUCTION = 'Risk.BuildingData.YearOfConstruction',

	PROPERTY_BUILDING_LIMIT = 'Risk.Limits.Building',
	PROPERTY_CONTENTS_LIMIT = 'Risk.Limits.Contents',
	PROPERTY_CONTENTS_USE_RCV = 'Risk.Limits.ContentsUseReplacementCostValue',
	PROPERTY_OTHER_STRUCTURES_LIMIT = 'Risk.Limits.OtherStructures',
	PROPERTY_ALE_LIMIT = 'Risk.Limits.AdditionalLivingExpense',

	INSURED_FIRST = 'NamedInsured.Name.FirstNameOrCompanyName',
	INSURED_LAST = 'NamedInsured.Name.LastName',
	INSURED_ADDRESS_1 = 'NamedInsured.MailingAddress.AddressLine1',
	INSURED_ADDRESS_2 = 'NamedInsured.MailingAddress.AddressLine2',
	INSURED_CITY = 'NamedInsured.MailingAddress.City',
	INSURED_STATE = 'NamedInsured.MailingAddress.State',
	INSURED_ZIP = 'NamedInsured.MailingAddress.PostalCode',
	INSURED_PHONE = 'NamedInsured.PhoneNumbers',
	INSURED_EMAIL = 'NamedInsured.Email',

	MORTGAGEE_ADDRESS_1 = 'Mortgagees.MailingAddress.AddressLine1',
	MORTGAGEE_ADDRESS_2 = 'Mortgagees.MailingAddress.AddressLine2',
	MORTGAGEE_CITY = 'Mortgagees.MailingAddress.City',
	MORTGAGEE_STATE = 'Mortgagees.MailingAddress.State',
	MORTGAGEE_ZIP = 'Mortgagees.MailingAddress.PostalCode',
	MORTGAGEE_LIEN_POSITION_NUMBER = 'Mortgagees.LienPositionNumber',
	MORTGAGEE_NAME = 'Mortgagees.Name',
	MORTGAGEE_LOAN_NUMBER = 'Mortgagees.LoanNumber',
	MORTGAGEE_INCLUDE_AS_THEIR_INTERESTS_MAY_APPEAR = 'Mortgagees.IncludeAsTheirInterestsMayAppear',
	MORTGAGEE_INCLUDE_ITS_SUCCESSORS_AND_OR_ASSIGNS = 'Mortgagees.IncludeItsSuccessorsAndOrAssigns',
	MORTGAGEE_BILL_MORTGAGEE = 'Mortgagees.BillMortgagee',
	MORTGAGEE_IS_MORTGAGEE_REQUIRED = 'Mortgagees.CoverageRequiredByMortgagee',
	MORTGAGEE_EMAIL = 'Mortgagees.Email',

	BUILDING_ADDRESS_1 = 'Buildings.Address.Address.AddressLine1',
	BUILDING_CITY = 'Buildings.Address.Address.City',
	BUILDING_STATE = 'Buildings.Address.Address.State',
	BUILDING_ZIP = 'Buildings.Address.Address.PostalCode',

	BUILDING_DESCRIPTION = 'Buildings.BuildingData.BuildingDescription',
	BUILDING_PARKING_TYPE = 'Buildings.BuildingData.ParkingType',
	BUILDING_CONSTRUCTION_TYPE = 'Buildings.BuildingData.ConstructionType',
	BUILDING_FOUNDATION_TYPE_DETAIL = 'Buildings.BuildingData.FoundationTypeDetail',
	BUILDING_RCV = 'Buildings.BuildingData.BuildingReplacementCostValue',
	BUILDING_FLOOD_ZONE = 'Buildings.BuildingData.FloodZone',
	BUILDING_BUILDING_USE = 'Buildings.BuildingData.BuildingUse',
	BUILDING_SQUARE_FEET = 'Buildings.BuildingData.SquareFeet',
	BUILDING_NUMBER_STORIES_ABOVE_GRADE = 'Buildings.BuildingData.NumberStoriesAboveGrade',
	BUILDING_YEAR_OF_CONSTRUCTION = 'Buildings.BuildingData.YearOfConstruction',

	BUILDING_BUILDING_LIMIT = 'Buildings.Limits.Building',
	BUILDING_CONTENTS_LIMIT = 'Buildings.Limits.Contents',
	BUILDING_BIEE_LIMIT = 'Buildings.Limits.BusinessIncomeExtraExpense',

	NONE = 'None',
}

namespace EndorsementEntityField {
	export function toEnumList(): EndorsementEntityField[] {
		let sectionNames: EndorsementEntityField[] = Object.keys(EndorsementEntityField)
			.filter((key: string) => key !== EndorsementEntityField.toEnumList.name)
			.map((key: string) => EndorsementEntityField[key]);
		return sectionNames;
	}

	export function getBuildingRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.BUILDING_ADDRESS_1,
			EndorsementEntityField.BUILDING_CITY,
			EndorsementEntityField.BUILDING_STATE,
			EndorsementEntityField.BUILDING_ZIP,
			EndorsementEntityField.BUILDING_DESCRIPTION,
			EndorsementEntityField.BUILDING_PARKING_TYPE,
			EndorsementEntityField.BUILDING_CONSTRUCTION_TYPE,
			EndorsementEntityField.BUILDING_FOUNDATION_TYPE_DETAIL,
			EndorsementEntityField.BUILDING_RCV,
			EndorsementEntityField.BUILDING_FLOOD_ZONE,
			EndorsementEntityField.BUILDING_BUILDING_USE,
			EndorsementEntityField.BUILDING_SQUARE_FEET,
			EndorsementEntityField.BUILDING_NUMBER_STORIES_ABOVE_GRADE,
			EndorsementEntityField.BUILDING_YEAR_OF_CONSTRUCTION,
			EndorsementEntityField.BUILDING_BUILDING_LIMIT,
			EndorsementEntityField.BUILDING_CONTENTS_LIMIT,
			EndorsementEntityField.BUILDING_BIEE_LIMIT,
		];
	}

	export function getMortgageeRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.MORTGAGEE_ADDRESS_1,
			EndorsementEntityField.MORTGAGEE_ADDRESS_2,
			EndorsementEntityField.MORTGAGEE_CITY,
			EndorsementEntityField.MORTGAGEE_STATE,
			EndorsementEntityField.MORTGAGEE_ZIP,
			EndorsementEntityField.MORTGAGEE_LIEN_POSITION_NUMBER,
			EndorsementEntityField.MORTGAGEE_NAME,
			EndorsementEntityField.MORTGAGEE_LOAN_NUMBER,
			EndorsementEntityField.MORTGAGEE_INCLUDE_AS_THEIR_INTERESTS_MAY_APPEAR,
			EndorsementEntityField.MORTGAGEE_INCLUDE_ITS_SUCCESSORS_AND_OR_ASSIGNS,
			EndorsementEntityField.MORTGAGEE_BILL_MORTGAGEE,
			EndorsementEntityField.MORTGAGEE_IS_MORTGAGEE_REQUIRED,
			EndorsementEntityField.MORTGAGEE_EMAIL,
		];
	}

	export function getDwellingPropertyAddressRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.PROPERTY_ADDRESS_1,
			EndorsementEntityField.PROPERTY_ADDRESS_2,
			EndorsementEntityField.PROPERTY_CITY,
			EndorsementEntityField.PROPERTY_STATE,
			EndorsementEntityField.PROPERTY_ZIP,
			EndorsementEntityField.PROPERTY_GPS_COORDIANTES,
		];
	}

	export function getDwellingPropertyDetailsRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.PROPERTY_OCCUPANCY_TYPE,
			EndorsementEntityField.PROPERTY_YEAR_ROOF_LAST_UPDATE,
			EndorsementEntityField.PROPERTY_IS_BELOW_GRADE_OR_ENCLOSED_AREA_FINISHED,
			EndorsementEntityField.PROPERTY_IS_GARAGE_ATTACHED,
			EndorsementEntityField.PROPERTY_CONSTRUCTION_TYPE,
			EndorsementEntityField.PROPERTY_FOUNDATION_TYPE_DETAIL,
			EndorsementEntityField.PROPERTY_RCV,
			EndorsementEntityField.PROPERTY_FLOOD_ZONE,
			EndorsementEntityField.PROPERTY_BUILDING_USE,
			EndorsementEntityField.PROPERTY_SQUARE_FEET,
			EndorsementEntityField.PROPERTY_NUMBER_STORIES_ABOVE_GRADE,
			EndorsementEntityField.PROPERTY_YEAR_OF_CONSTRUCTION,
		];
	}

	export function getDwellingLimitsRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.PROPERTY_BUILDING_LIMIT,
			EndorsementEntityField.PROPERTY_CONTENTS_LIMIT,
			EndorsementEntityField.PROPERTY_CONTENTS_USE_RCV,
			EndorsementEntityField.PROPERTY_OTHER_STRUCTURES_LIMIT,
			EndorsementEntityField.PROPERTY_ALE_LIMIT,
		];
	}

	export function getInsuredRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.INSURED_FIRST,
			EndorsementEntityField.INSURED_LAST,
			EndorsementEntityField.INSURED_ADDRESS_1,
			EndorsementEntityField.INSURED_ADDRESS_2,
			EndorsementEntityField.INSURED_CITY,
			EndorsementEntityField.INSURED_STATE,
			EndorsementEntityField.INSURED_ZIP,
			EndorsementEntityField.INSURED_PHONE,
			EndorsementEntityField.INSURED_EMAIL,
		];
	}

	export function getPerilRelatedEntityFields(): EndorsementEntityField[] {
		return [
			EndorsementEntityField.DEDUCTIBLES,
		];
	}
}

export default EndorsementEntityField;